<template>
    <div class="contact-support mb-3 mt-page">

        <data-form
            title="Contact Support"
            save-button-label="Submit"
            :field-model="supportModel"
            :field-groups="fieldGroups"
            :on-submit-handler="onSubmit"
            cancel-route="/"
            submit-success-message="Thank you for your feedback"
            submit-error-message="An error occurred"
            submit-success-route="/">
        </data-form>

        <div class="frame p-3 pt-4 mt-3">
            <h5 class="mb-2">Please describe your question or issue</h5>
            <b-textarea rows="6" v-model="message">
            </b-textarea>
        </div>

    </div>
</template>

<script>
import Vue from 'vue'
import { required } from 'vuelidate/lib/validators'

export default Vue.extend({
    name: "ContactSupport",
    data() {
        return {
            message: "",
            supportModel: {
                fields: {
                    name: {
                        label: 'Name',
                        type: 'text',
                        validations: { required },
                    },
                    email: {
                        label: 'E-Mail',
                        type: 'email',
                        validations: { required },
                    },
                    browser: {
                        label: 'Browser',
                        type: 'select',
                        validations: { required },
                        options: {
                            SAFARI: 'Safari',
                            CHROME: 'Chrome',
                            IE: 'Internet Explorer',
                            EDGE: 'Edge',
                        }
                    },
                    system: {
                        label: 'Operating System',
                        type: 'select',
                        validations: { required },
                        options: {
                            MAC: 'Mac',
                            WINDOWS: 'Windows',
                            CHROME_OS: 'Chrome OS',
                            IOS: 'iOS',
                            ANDROID: 'Android',
                            LINUX: 'Linux'
                        },
                    },
                }
            },
            fieldGroups: [['name', 'email', 'browser', 'system']]
        }
    },
    methods: {
        onSubmit(modelInstance) {
            this.$api.sendSupportRequest(modelInstance, this.message)
        }
    }
})
</script>

<style scoped>

</style>
